import React, { useCallback } from "react";
import {

  Grid, Box, Typography
} from "@mui/material";
import { useHistory } from "react-router-dom";

import { useDispatch } from "react-redux";
import { selected } from "../../features/patient";
import AccessLocalStorage from "../../services/localStorage";
import { blackcolor, darkcolor, pcolor, whitecolor } from "../../style2";


// const useStyles = makeStyles((theme) => ({
//   patientline: {
//     border: "0.6px solid rgba(133, 138, 145, 0.4)",
//   },
//   patientname: {
//     fontWeight: "bold",
//     fontSize: 16,
//     color: pcolor,
//   },
//   patientnhsnumber: {
//     fontWeight: "bold",
//     fontSize: 14,
//     color: "#001244",
//   },
//   patientdiagnosis: {
//     fontSize: 14,
//     color: "#001244",
//   },
//   patientteam: {
//     fontSize: 14,
//     color: pcolor,
//   },
//   patientshared: {
//     fontSize: 14,
//     color: pcolor,
//   },
//   avatar: {
//     background: "#4bc0a9",
//   },
//   listitembutton: {
//     "&:hover": {
//       color: "#EBEEFF",
//     },
//   },
// }));

// const patientline = {
//   border: "0.6px solid rgba(133, 138, 145, 0.4)",
// };
const patientname = {
  fontWeight: "bold",
  fontSize: 16,
  color: pcolor,
};
const patientnhsnumber = {
  fontWeight: "bold",
  fontSize: 14,
  color: darkcolor,
};
// const patientdiagnosis = {
//   fontSize: 14,
//   color: "#001244",
// };
// const patientteam = {
//   fontSize: 14,
//   color: pcolor,
// };
// const patientshared = {
//   fontSize: 14,
//   color: pcolor,
// };
// const avatar = {
//   background: "#4bc0a9",
// };
// const listitembutton = {
//   "&:hover": {
//     color: "#EBEEFF",
//   },
// };

function PatientList({ patients, page, rowsPerPage }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const ls = new AccessLocalStorage();
  const handleFirstOnClick = (user) => {
    if (!user.isDeleted) {
      dispatch(selected(user));
      ls.setCurrentPatient(user);
      handleOnClick();
    }
  };
  const handleOnClick = useCallback(
    () => history.push("/patient_profile"),
    [history]
  );

  return (
    <>
      {patients
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((user) => {
          return (
            <>
              <Grid container spacing={2} title={user.isDeleted ? "Patient is archived" : ""} alignItems="center" key={user.id}
                onClick={() => handleFirstOnClick(user)}
                sx={{ borderBottom: "#F1EFDF solid 2px", marginBottom: "12px", paddingBottom: "12px", cursor: user.isDeleted ? "default" : "pointer" }}>
                <Grid item>
                  <div style={{
                    textAlign: "center", backgroundColor: user.isDeleted ? blackcolor : pcolor, color: user.isDeleted ? "#808080" : whitecolor,
                    height: "60px",
                    width: "60px", borderRadius: "30px", fontSize: "1.8rem", padding: "10px"
                  }}>
                    {user.user.firstName.charAt(0)}
                  </div>
                </Grid>
                <Grid item xs={10} sm container alignItems="center">
                  <Grid item xs container direction="column" spacing={2}>
                    <Grid item xs>
                      <Typography sx={patientname} >
                        {user.user.firstName + " " + user.user.surname}
                      </Typography>
                      {user.user.nhsNumber != undefined ? <Typography sx={patientnhsnumber}>{user.user.nhsNumber}</Typography> : null}
                      {user.isDeleted ? <Typography sx={{ fontSize: "0.865rem" }}>Archived</Typography> : null}
                    </Grid>
                  </Grid>
                  <Box m={4} />
                </Grid>
              </Grid>
            </>
          );
        })}
    </>
  );
}

export default PatientList;
